
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/graduates",
      function () {
        return require("private-next-pages/graduates/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/graduates"])
      });
    }
  